(function () {
  "use strict";

  if (
    window.PromoWidget &&
    typeof window.PromoWidget.scheduleUpdate === "function"
  ) {
    window.PromoWidget.scheduleUpdate(0);
    return;
  }

  const PromoWidget = {
    config: {
      promotions: [
        {
          id: "free-shipping",
          type: "shipping",
          enabled: true,
          threshold: 79.99,
          icon: "🚚",
          pending: "la spedizione gratuita",
          completed: "Hai ottenuto la spedizione gratuita."
        },

        {
          id: "discount-10",
          type: "discount",
          enabled: false,
          threshold: 95.00,
          icon: "🏷️",
          pending: "ottenere il 10% di sconto",
          completed:
            "Hai raggiunto la soglia per ottenere il 10% di sconto."
        },

        {
          id: "free-gift",
          type: "gift",
          enabled: false,
          threshold: 120.00,
          icon: "🎁",
          pending: "ricevere il nostro omaggio",
          completed:
            "Hai raggiunto la soglia per ricevere il nostro omaggio."
        },

        {
          id: "discount-15",
          type: "discount",
          enabled: false,
          threshold: 150.00,
          icon: "💎",
          pending: "ottenere il 15% di sconto",
          completed:
            "Hai raggiunto la soglia per ottenere il 15% di sconto."
        }
      ]
    },

    observer: null,
    updateTimer: null,
    eventsBound: false,

    init() {
      this.bindEvents();
      this.startObserver();
      this.scheduleUpdate(0);
    },

    getWidgets() {
      return Array.from(
        document.querySelectorAll("[data-promo-widget]")
      );
    },

    getWidgetElements(widget) {
      if (!(widget instanceof Element)) {
        return null;
      }

      const shipping = widget.querySelector(
        "[data-promo-shipping]"
      );

      const promotions = widget.querySelector(
        "[data-promo-promotions]"
      );

      const form = widget.closest("form");

      const subtotal = form
        ? form.querySelector("[data-subtotal]")
        : null;

      if (!shipping || !promotions || !subtotal) {
        return null;
      }

      return {
        widget,
        shipping,
        promotions,
        subtotal
      };
    },

    scheduleUpdate(delay = 50) {
      window.clearTimeout(this.updateTimer);

      this.updateTimer = window.setTimeout(() => {
        this.update();
      }, delay);
    },

    update() {
      const widgets = this.getWidgets();

      if (!widgets.length) {
        return;
      }

      widgets.forEach(widget => {
        this.updateWidget(widget);
      });
    },

    updateWidget(widget) {
      const elements = this.getWidgetElements(widget);

      if (!elements) {
        return;
      }

      const subtotal = this.getSubtotal(elements.subtotal);

      if (!Number.isFinite(subtotal)) {
        return;
      }

      this.renderShipping(
        elements.shipping,
        subtotal
      );

      this.renderPromotions(
        elements.promotions,
        subtotal
      );
    },

    getSubtotal(subtotalElement) {
      if (!subtotalElement) {
        return 0;
      }

      const visibleSubtotal = this.parseMoney(
        subtotalElement.textContent
      );

      if (Number.isFinite(visibleSubtotal)) {
        return visibleSubtotal;
      }

      const cents = Number(
        subtotalElement.dataset.subtotalCents
      );

      if (Number.isFinite(cents)) {
        return cents / 100;
      }

      return 0;
    },

    parseMoney(value) {
      if (typeof value !== "string") {
        return 0;
      }

      let numeric = value
        .replace(/\s/g, "")
        .replace(/[^\d,.-]/g, "");

      if (!numeric) {
        return 0;
      }

      const lastComma = numeric.lastIndexOf(",");
      const lastDot = numeric.lastIndexOf(".");

      if (lastComma > -1 && lastDot > -1) {
        if (lastComma > lastDot) {
          numeric = numeric
            .replace(/\./g, "")
            .replace(",", ".");
        } else {
          numeric = numeric.replace(/,/g, "");
        }
      } else if (lastComma > -1) {
        const decimalDigits =
          numeric.length - lastComma - 1;

        if (decimalDigits === 2) {
          numeric = numeric.replace(",", ".");
        } else {
          numeric = numeric.replace(/,/g, "");
        }
      } else if (lastDot > -1) {
        const decimalDigits =
          numeric.length - lastDot - 1;

        if (decimalDigits !== 2) {
          numeric = numeric.replace(/\./g, "");
        }
      }

      const parsed = Number.parseFloat(numeric);

      return Number.isFinite(parsed)
        ? parsed
        : 0;
    },

    renderShipping(container, subtotal) {
      const shipping = this.config.promotions.find(
        promotion =>
          promotion.enabled &&
          promotion.type === "shipping"
      );

      if (!shipping || !container) {
        if (container) {
          container.innerHTML = "";
        }

        return;
      }

      const data = this.calculateProgress(
        subtotal,
        shipping.threshold
      );

      container.innerHTML =
        this.createShipping(shipping, data);
    },

    renderPromotions(container, subtotal) {
      if (!container) {
        return;
      }

      const promotions = this.config.promotions
        .filter(
          promotion =>
            promotion.enabled &&
            promotion.type !== "shipping"
        )
        .sort(
          (first, second) =>
            first.threshold - second.threshold
        );

      if (!promotions.length) {
        container.innerHTML = "";
        return;
      }

      container.innerHTML = promotions
        .map(promotion => {
          const data = this.calculateProgress(
            subtotal,
            promotion.threshold
          );

          return this.createPromotion(
            promotion,
            data
          );
        })
        .join("");
    },

    createShipping(promotion, data) {
      const statusClass = data.completed
        ? "promo-row--completed"
        : "promo-row--pending";

      const message = data.completed
        ? `✅ Complimenti! ${promotion.completed}`
        : `${promotion.icon} Mancano solo <strong>${data.remaining}</strong> per ${promotion.pending}.`;

      const progressClass = data.completed
        ? "promo-progress__bar promo-progress__bar--completed"
        : "promo-progress__bar";

      return `
        <div class="promo-row ${statusClass}">
          ${message}
        </div>

        <div
          class="promo-progress"
          role="progressbar"
          aria-label="Progresso spedizione gratuita"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow="${data.progress}"
        >
          <div
            class="${progressClass}"
            style="width: ${data.progress}%"
          ></div>
        </div>
      `;
    },

    createPromotion(promotion, data) {
      const statusClass = data.completed
        ? "promo-row--completed"
        : "promo-row--pending";

      const message = data.completed
        ? `✅ Complimenti! ${promotion.completed}`
        : `${promotion.icon} Mancano solo <strong>${data.remaining}</strong> per ${promotion.pending}.`;

      return `
        <div class="promo-row ${statusClass}">
          ${message}
        </div>
      `;
    },

calculateProgress(current, target) {
  /*
   * Tutti i calcoli monetari vengono effettuati
   * in centesimi per evitare errori decimali.
   */

  const currentCents = Math.max(
    0,
    Math.round((Number(current) || 0) * 100)
  );

  const targetCents = Math.max(
    0,
    Math.round((Number(target) || 0) * 100)
  );

  const completed =
    targetCents > 0 &&
    currentCents >= targetCents;

  const progress =
    targetCents > 0
      ? Math.min(
          Math.max(
            (currentCents / targetCents) * 100,
            0
          ),
          100
        )
      : 0;

  const remainingCents = Math.max(
    0,
    targetCents - currentCents
  );

  return {
    completed,
    progress: Number(progress.toFixed(2)),
    remaining: this.formatMoney(
      remainingCents / 100
    )
  };
},

    formatMoney(amount) {
      const currency =
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
          ? window.Shopify.currency.active
          : "EUR";

      try {
        return new Intl.NumberFormat(
          document.documentElement.lang || "it-IT",
          {
            style: "currency",
            currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        ).format(amount);
      } catch (error) {
        return `${amount
          .toFixed(2)
          .replace(".", ",")}€`;
      }
    },

    bindEvents() {
      if (this.eventsBound) {
        return;
      }

      this.eventsBound = true;

      const events = [
        "cart:updated",
        "cart:refresh",
        "cart:build",
        "ajaxProduct:added",
        "product:added",
        "shopify:section:load",
        "shopify:section:reorder"
      ];

      events.forEach(eventName => {
        document.addEventListener(
          eventName,
          () => {
            this.scheduleUpdate(100);
          }
        );
      });

      document.addEventListener(
        "change",
        event => {
          if (
            event.target.closest(
              ".cart__drawer-form, " +
              "#CartPageForm, " +
              "[data-cart-drawer]"
            )
          ) {
            this.scheduleUpdate(150);
          }
        }
      );

      document.addEventListener(
        "click",
        event => {
          if (
            event.target.closest(
              ".cart__drawer-form button, " +
              ".cart__drawer-form a, " +
              "#CartPageForm button, " +
              "#CartPageForm a, " +
              "[data-cart-drawer] button, " +
              "[data-cart-drawer] a"
            )
          ) {
            this.scheduleUpdate(200);
          }
        }
      );
    },

    startObserver() {
      if (
        !document.body ||
        this.observer
      ) {
        return;
      }

      this.observer = new MutationObserver(
        mutations => {
          const relevantMutation =
            mutations.some(mutation => {
              const target =
                mutation.target instanceof Element
                  ? mutation.target
                  : mutation.target.parentElement;

              if (
                target &&
                target.closest(
                  "[data-promo-widget]"
                )
              ) {
                return false;
              }

              if (
                target &&
                target.closest(
                  "[data-subtotal], " +
                  ".cart__drawer-form, " +
                  "#CartPageForm, " +
                  "[data-cart-drawer]"
                )
              ) {
                return true;
              }

              return Array.from(
                mutation.addedNodes
              ).some(node => {
                if (!(node instanceof Element)) {
                  return false;
                }

                return Boolean(
                  node.matches(
                    "[data-promo-widget], " +
                    "[data-subtotal], " +
                    ".cart__drawer-form, " +
                    "#CartPageForm, " +
                    "[data-cart-drawer]"
                  ) ||
                  node.querySelector(
                    "[data-promo-widget], " +
                    "[data-subtotal], " +
                    ".cart__drawer-form, " +
                    "#CartPageForm, " +
                    "[data-cart-drawer]"
                  )
                );
              });
            });

          if (relevantMutation) {
            this.scheduleUpdate(75);
          }
        }
      );

      this.observer.observe(
        document.body,
        {
          childList: true,
          subtree: true,
          characterData: true
        }
      );
    }
  };

  function startPromoWidget() {
    PromoWidget.init();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startPromoWidget,
      { once: true }
    );
  } else {
    startPromoWidget();
  }

  window.PromoWidget = PromoWidget;
})();